<template>
  <div
    class="py-4 p-st"
    :class="{
      'bg-light': !nightMode,
      'bg-dark2': nightMode,
      'text-light': nightMode,
    }"
  >
    <div class="container">
        <div
          class="text-center section-head"
          data-aos="fade"
          data-aos-once="true"
          data-aos-duration="800"
        >
          <h2
            class="title"
            :class="{ pgray: !nightMode, 'text-light': nightMode }"
          >
            About Me
          </h2>
          <hr
            class="title-rule"
            :class="{ pgray: !nightMode, 'bg-secondary': nightMode }"
          />
        </div>
      <div class="row">
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12">
          <Timeline :data="education" :nightMode="nightMode" />
        </div>
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12">
          <Timeline :data="experience" :nightMode="nightMode" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Timeline from "./helpers/Timeline";
import info from "../../info";

export default {
  name: "About",
  components: {
    Timeline,
  },
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      education: {
        title: "Education",
        data: info.education,
      },
      experience: {
        title: "Experience",
        data: info.experience,
      },
    };
  },
};
</script>

<style scoped>
.section-head {
  margin-bottom: 2rem;
}

.title {
  font-size: clamp(1.5rem, 3vw, 1.875rem);
  font-weight: 600;
  letter-spacing: -0.02em;
}

.title-rule {
  width: 48px;
  height: 3px;
  margin: 0.75rem auto 0;
  border: none;
  background: var(--color-accent, #475569);
  opacity: 0.9;
}
</style>
